import { waadooIcons } from '../ui/icons/waadooIcons';
import type { CardTag } from './cardPresentation';

const LockIcon = waadooIcons.locked;

/**
 * A tag of « Créer »: the grey pill, or the red one with a lock for `admin`
 * (`.waadoo-create-card__tag` in styles.css). On a template's card, and on
 * the technical tabs of an admin's row (CreatePage.tsx), so that both read
 * the same.
 *
 * `decorative` hides it from assistive technologies, for a caller that says
 * the same in words of its own.
 */
export function TemplateTag(props: { tag: CardTag; decorative?: boolean }) {
  const { tag, decorative = false } = props;
  return (
    <span
      className="waadoo-create-card__tag"
      data-kind={tag.kind}
      aria-hidden={decorative ? 'true' : undefined}
    >
      {tag.kind === 'admin' && <LockIcon aria-hidden focusable="false" />}
      {tag.label}
    </span>
  );
}
